// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'contracts.contractFormPage.titleEdit': 'Editar contrato',
    'contracts.contractFormPage.titleNew': 'Novo contrato',
    'contracts.contractFormPage.eyebrow': 'Contratos',
    'contracts.contractFormPage.tryAgain': 'Tentar de novo',
    'contracts.contractFormPage.toastUpdated': 'Contrato atualizado.',
    'contracts.contractFormPage.toastCreated': 'Contrato criado.',
    'contracts.contractFormPage.errSelectCustomer': 'Selecione o cliente',
    'contracts.contractFormPage.errNameRequired': 'Informe o nome do contrato',
    'contracts.contractFormPage.errInvalidLink': 'Link inválido (use http:// ou https://)',
    'contracts.contractFormPage.pivotLocationHint': 'Clique no mapa para marcar a posição, ou arraste o marcador.',
    'contracts.contractFormPage.mapTitle': 'Coordenadas no mapa',
    'contracts.contractFormPage.pairPivot': 'Pivô',
    'contracts.contractFormPage.pairSede': 'Apoio/Sede',
    'contracts.contractFormPage.labelSedeLatitude': 'Latitude Apoio/Sede',
    'contracts.contractFormPage.labelSedeLongitude': 'Longitude Apoio/Sede',
    'contracts.contractFormPage.sectionIdentification': 'Identificação',
    'contracts.contractFormPage.sectionParties': 'Partes e local',
    'contracts.contractFormPage.sectionOperation': 'Operação',
    'contracts.contractFormPage.sectionCoordinates': 'Coordenadas',
    'contracts.contractFormPage.sectionDocuments': 'Documentos e links',
    'contracts.contractFormPage.sectionExtras': 'Complementos',
    'contracts.contractFormPage.clearPosition': 'Limpar posição',
    'contracts.contractFormPage.labelCustomer': 'Cliente',
    'contracts.contractFormPage.searchCustomer': 'Buscar cliente…',
    'contracts.contractFormPage.labelContractNumber': 'Nº do contrato',
    'contracts.contractFormPage.labelFront': 'Frente',
    'contracts.contractFormPage.labelProducer': 'Produtor (cooperante)',
    'contracts.contractFormPage.labelDupla': 'Dupla',
    'contracts.contractFormPage.searchDupla': 'Buscar dupla…',
    'contracts.contractFormPage.duplaHelper': 'Decide em qual Frente de Trabalho o contrato aparece. Sem dupla, vale o cliente.',
    'contracts.contractFormPage.labelProduct': 'Produto',
    'contracts.contractFormPage.searchProduct': 'Buscar produto…',
    'contracts.contractFormPage.labelFarm': 'Fazenda',
    'contracts.contractFormPage.labelDestination': 'Destino',
    'contracts.contractFormPage.searchDestination': 'Buscar destino…',
    'contracts.contractFormPage.destLegacyHelper': 'Destino legado. Selecione uma UBS ativa antes de salvar.',
    'contracts.contractFormPage.destOnlyActiveUnits': 'Somente UBS ativas.',
    'contracts.contractFormPage.legacyDestAlert': 'Este contrato tem um destino legado que não é uma UBS ativa. O valor foi preservado, mas selecione uma UBS válida antes de salvar.',
    'contracts.contractFormPage.labelMunicipality': 'Município',
    'contracts.contractFormPage.municipalityPlaceholder': 'Cidade/UF (ex.: Paracatu/MG)',
    'contracts.contractFormPage.labelSeason': 'Safra',
    'contracts.contractFormPage.labelHybrid': 'Híbrido/cultivar',
    'contracts.contractFormPage.labelHectares': 'Hectares',
    'contracts.contractFormPage.labelKm': 'KM vazio',
    'contracts.contractFormPage.labelToll': 'Pedágio',
    'contracts.contractFormPage.labelEstimatedLoads': 'Cargas prev.',
    'contracts.contractFormPage.labelShare': 'Rateio/participação',
    'contracts.contractFormPage.labelSituation': 'Situação',
    'contracts.contractFormPage.statusActive': 'Ativo',
    'contracts.contractFormPage.statusClosed': 'Encerrado',
    'contracts.contractFormPage.labelFilialTms': 'Filial TMS',
    'contracts.contractFormPage.labelFilialGct': 'Filial GCT',
    'contracts.contractFormPage.labelRc': 'RC',
    'contracts.contractFormPage.labelOperacao': 'Operação',
    'contracts.contractFormPage.helperOperacao': 'Onde o contrato conta na aba Planejamento: hectares, caminhões ou os dois.',
    'contracts.contractFormPage.operacao.Colheita': 'Colheita',
    'contracts.contractFormPage.operacao.Transporte': 'Transporte',
    'contracts.contractFormPage.operacao.Colheita e Transporte': 'Colheita e Transporte',
    'contracts.contractFormPage.labelHarvestWeek': 'Semana colheita',
    'contracts.contractFormPage.helperHarvestWeek': 'O Hub grava a segunda-feira da semana. É a semana da aba Planejamento do Dashboard.',
    'contracts.contractFormPage.labelService': 'Serviço',
    'contracts.contractFormPage.labelLatitude': 'Latitude Pivô',
    'contracts.contractFormPage.labelLongitude': 'Longitude Pivô',
    'contracts.contractFormPage.labelGeofenceRadius': 'Raio da cerca em km',
    'contracts.contractFormPage.radiusPlaceholder': 'Padrão 1 km',
    'contracts.contractFormPage.labelLegalContract': 'Contrato Jurídico',
    'contracts.contractFormPage.labelLink': 'Link legado',
    'contracts.contractFormPage.labelExtraInfo': 'Informação complementar',
    'contracts.contractFormPage.labelNotes': 'Observações',
  },
  en: {
    'contracts.contractFormPage.titleEdit': 'Edit contract',
    'contracts.contractFormPage.titleNew': 'New contract',
    'contracts.contractFormPage.eyebrow': 'Contracts',
    'contracts.contractFormPage.tryAgain': 'Try again',
    'contracts.contractFormPage.toastUpdated': 'Contract updated.',
    'contracts.contractFormPage.toastCreated': 'Contract created.',
    'contracts.contractFormPage.errSelectCustomer': 'Select the customer',
    'contracts.contractFormPage.errNameRequired': 'Enter the contract name',
    'contracts.contractFormPage.errInvalidLink': 'Invalid link (use http:// or https://)',
    'contracts.contractFormPage.pivotLocationHint': 'Click on the map to mark the position, or drag the marker.',
    'contracts.contractFormPage.mapTitle': 'Coordinates on the map',
    'contracts.contractFormPage.pairPivot': 'Pivot',
    'contracts.contractFormPage.pairSede': 'Support/HQ',
    'contracts.contractFormPage.labelSedeLatitude': 'Support/HQ latitude',
    'contracts.contractFormPage.labelSedeLongitude': 'Support/HQ longitude',
    'contracts.contractFormPage.sectionIdentification': 'Identification',
    'contracts.contractFormPage.sectionParties': 'Parties and location',
    'contracts.contractFormPage.sectionOperation': 'Operation',
    'contracts.contractFormPage.sectionCoordinates': 'Coordinates',
    'contracts.contractFormPage.sectionDocuments': 'Documents and links',
    'contracts.contractFormPage.sectionExtras': 'Additional',
    'contracts.contractFormPage.clearPosition': 'Clear position',
    'contracts.contractFormPage.labelCustomer': 'Customer',
    'contracts.contractFormPage.searchCustomer': 'Search customer…',
    'contracts.contractFormPage.labelContractNumber': 'Contract no.',
    'contracts.contractFormPage.labelFront': 'Work front',
    'contracts.contractFormPage.labelProducer': 'Producer (partner)',
    'contracts.contractFormPage.labelDupla': 'Pair',
    'contracts.contractFormPage.searchDupla': 'Search pair…',
    'contracts.contractFormPage.duplaHelper': 'Decides in which Work Front the contract appears. Without a pair, the customer scope applies.',
    'contracts.contractFormPage.labelProduct': 'Product',
    'contracts.contractFormPage.searchProduct': 'Search product…',
    'contracts.contractFormPage.labelFarm': 'Farm',
    'contracts.contractFormPage.labelDestination': 'Destination',
    'contracts.contractFormPage.searchDestination': 'Search destination…',
    'contracts.contractFormPage.destLegacyHelper': 'Legacy destination. Select an active UBS before saving.',
    'contracts.contractFormPage.destOnlyActiveUnits': 'Active UBS only.',
    'contracts.contractFormPage.legacyDestAlert': 'This contract has a legacy destination that is not an active UBS. The value was preserved, but select a valid UBS before saving.',
    'contracts.contractFormPage.labelMunicipality': 'Municipality',
    'contracts.contractFormPage.municipalityPlaceholder': 'City/State (e.g. Paracatu/MG)',
    'contracts.contractFormPage.labelSeason': 'Season',
    'contracts.contractFormPage.labelHybrid': 'Hybrid/cultivar',
    'contracts.contractFormPage.labelHectares': 'Hectares',
    'contracts.contractFormPage.labelKm': 'Empty km',
    'contracts.contractFormPage.labelToll': 'Toll',
    'contracts.contractFormPage.labelEstimatedLoads': 'Est. loads',
    'contracts.contractFormPage.labelShare': 'Split/share',
    'contracts.contractFormPage.labelSituation': 'Status',
    'contracts.contractFormPage.statusActive': 'Active',
    'contracts.contractFormPage.statusClosed': 'Closed',
    'contracts.contractFormPage.labelFilialTms': 'TMS branch',
    'contracts.contractFormPage.labelFilialGct': 'GCT branch',
    'contracts.contractFormPage.labelRc': 'RC',
    'contracts.contractFormPage.labelOperacao': 'Operation',
    'contracts.contractFormPage.helperOperacao': 'Where the contract counts in the Planning tab: hectares, trucks or both.',
    'contracts.contractFormPage.operacao.Colheita': 'Harvest',
    'contracts.contractFormPage.operacao.Transporte': 'Transport',
    'contracts.contractFormPage.operacao.Colheita e Transporte': 'Harvest and Transport',
    'contracts.contractFormPage.labelHarvestWeek': 'Harvest week',
    'contracts.contractFormPage.helperHarvestWeek': 'The Hub saves the Monday of the week. It is the week of the Dashboard Planning tab.',
    'contracts.contractFormPage.labelService': 'Service',
    'contracts.contractFormPage.labelLatitude': 'Pivot latitude',
    'contracts.contractFormPage.labelLongitude': 'Pivot longitude',
    'contracts.contractFormPage.labelGeofenceRadius': 'Geofence radius in km',
    'contracts.contractFormPage.radiusPlaceholder': 'Default 1 km',
    'contracts.contractFormPage.labelLegalContract': 'Legal contract',
    'contracts.contractFormPage.labelLink': 'Legacy link',
    'contracts.contractFormPage.labelExtraInfo': 'Additional information',
    'contracts.contractFormPage.labelNotes': 'Notes',
  },
  es: {
    'contracts.contractFormPage.titleEdit': 'Editar contrato',
    'contracts.contractFormPage.titleNew': 'Nuevo contrato',
    'contracts.contractFormPage.eyebrow': 'Contratos',
    'contracts.contractFormPage.tryAgain': 'Intentar de nuevo',
    'contracts.contractFormPage.toastUpdated': 'Contrato actualizado.',
    'contracts.contractFormPage.toastCreated': 'Contrato creado.',
    'contracts.contractFormPage.errSelectCustomer': 'Selecciona el cliente',
    'contracts.contractFormPage.errNameRequired': 'Ingresa el nombre del contrato',
    'contracts.contractFormPage.errInvalidLink': 'Enlace inválido (usa http:// o https://)',
    'contracts.contractFormPage.pivotLocationHint': 'Haz clic en el mapa para marcar la posición, o arrastra el marcador.',
    'contracts.contractFormPage.mapTitle': 'Coordenadas en el mapa',
    'contracts.contractFormPage.pairPivot': 'Pivote',
    'contracts.contractFormPage.pairSede': 'Apoyo/Sede',
    'contracts.contractFormPage.labelSedeLatitude': 'Latitud Apoyo/Sede',
    'contracts.contractFormPage.labelSedeLongitude': 'Longitud Apoyo/Sede',
    'contracts.contractFormPage.sectionIdentification': 'Identificación',
    'contracts.contractFormPage.sectionParties': 'Partes y ubicación',
    'contracts.contractFormPage.sectionOperation': 'Operación',
    'contracts.contractFormPage.sectionCoordinates': 'Coordenadas',
    'contracts.contractFormPage.sectionDocuments': 'Documentos y enlaces',
    'contracts.contractFormPage.sectionExtras': 'Complementos',
    'contracts.contractFormPage.clearPosition': 'Limpiar posición',
    'contracts.contractFormPage.labelCustomer': 'Cliente',
    'contracts.contractFormPage.searchCustomer': 'Buscar cliente…',
    'contracts.contractFormPage.labelContractNumber': 'N.º de contrato',
    'contracts.contractFormPage.labelFront': 'Frente de trabajo',
    'contracts.contractFormPage.labelProducer': 'Productor (cooperante)',
    'contracts.contractFormPage.labelDupla': 'Pareja',
    'contracts.contractFormPage.searchDupla': 'Buscar pareja…',
    'contracts.contractFormPage.duplaHelper': 'Decide en qué Frente de trabajo aparece el contrato. Sin pareja, vale el cliente.',
    'contracts.contractFormPage.labelProduct': 'Producto',
    'contracts.contractFormPage.searchProduct': 'Buscar producto…',
    'contracts.contractFormPage.labelFarm': 'Finca',
    'contracts.contractFormPage.labelDestination': 'Destino',
    'contracts.contractFormPage.searchDestination': 'Buscar destino…',
    'contracts.contractFormPage.destLegacyHelper': 'Destino heredado. Selecciona una UBS activa antes de guardar.',
    'contracts.contractFormPage.destOnlyActiveUnits': 'Solo UBS activas.',
    'contracts.contractFormPage.legacyDestAlert': 'Este contrato tiene un destino heredado que no es una UBS activa. El valor se conservó, pero selecciona una UBS válida antes de guardar.',
    'contracts.contractFormPage.labelMunicipality': 'Municipio',
    'contracts.contractFormPage.municipalityPlaceholder': 'Ciudad/UF (ej.: Paracatu/MG)',
    'contracts.contractFormPage.labelSeason': 'Zafra',
    'contracts.contractFormPage.labelHybrid': 'Híbrido/cultivar',
    'contracts.contractFormPage.labelHectares': 'Hectáreas',
    'contracts.contractFormPage.labelKm': 'KM vacío',
    'contracts.contractFormPage.labelToll': 'Peaje',
    'contracts.contractFormPage.labelEstimatedLoads': 'Cargas prev.',
    'contracts.contractFormPage.labelShare': 'Prorrateo/participación',
    'contracts.contractFormPage.labelSituation': 'Situación',
    'contracts.contractFormPage.statusActive': 'Activo',
    'contracts.contractFormPage.statusClosed': 'Cerrado',
    'contracts.contractFormPage.labelFilialTms': 'Sucursal TMS',
    'contracts.contractFormPage.labelFilialGct': 'Sucursal GCT',
    'contracts.contractFormPage.labelRc': 'RC',
    'contracts.contractFormPage.labelOperacao': 'Operación',
    'contracts.contractFormPage.helperOperacao': 'Dónde cuenta el contrato en la pestaña Planificación: hectáreas, camiones o ambos.',
    'contracts.contractFormPage.operacao.Colheita': 'Cosecha',
    'contracts.contractFormPage.operacao.Transporte': 'Transporte',
    'contracts.contractFormPage.operacao.Colheita e Transporte': 'Cosecha y Transporte',
    'contracts.contractFormPage.labelHarvestWeek': 'Semana de cosecha',
    'contracts.contractFormPage.helperHarvestWeek': 'El Hub guarda el lunes de la semana. Es la semana de la pestaña Planificación del Dashboard.',
    'contracts.contractFormPage.labelService': 'Servicio',
    'contracts.contractFormPage.labelLatitude': 'Latitud Pivote',
    'contracts.contractFormPage.labelLongitude': 'Longitud Pivote',
    'contracts.contractFormPage.labelGeofenceRadius': 'Radio de la geocerca en km',
    'contracts.contractFormPage.radiusPlaceholder': 'Predeterminado 1 km',
    'contracts.contractFormPage.labelLegalContract': 'Contrato jurídico',
    'contracts.contractFormPage.labelLink': 'Enlace heredado',
    'contracts.contractFormPage.labelExtraInfo': 'Información complementaria',
    'contracts.contractFormPage.labelNotes': 'Observaciones',
  },
}
